export default __webpack_public_path__ + "static/media/bulleted-list-icon.5f49eb9e.svg";